import React, { useEffect, useState, useRef } from 'react';
import FacilitySignatureCanvas from './FacilitySignature';
import { useUser } from "../UserContext";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate } from 'react-router-dom';
import Loader from '../Loader';
import Master from '../partials/master';

const FacilityDetail = () => {
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [formData, setFormData] = useState({});
    const [loading, setLoading] = useState(false);
    const [facility, setFacility] = useState(null);
    const [questions, setQuestions] = useState([]);
    const [certificateEmails, setCertificateEmails] = useState([]);
    const [birthdayEmails, setBirthdayEmails] = useState([]);
    const [selectedQuestionIds, setSelectedQuestionIds] = useState([]);
    const [errors, setErrors] = useState({});

    const user = useUser();
    const userRole = user?.user?.user?.role;
    const facilityId = user?.user?.facility?.id;

    const token = localStorage.getItem("token");
    const navigate = useNavigate();
    const cacheBuster = Date.now();
    const apiCalledRef = useRef(false);

    useEffect(() => {


        if (userRole === 'examiner' || userRole === 'trainings_user') {
            navigate('/dashboard');
        }
        if (!token) {
            navigate('/login');
            return;
        }

        // if (!apiCalledRef.current) {
        //     apiCalledRef.current = true;
            fetchFacility();
            fetchQuestions();
        // }



        const timer = setTimeout(() => {
            setLoading(false); // Stop the loader after 3 seconds
        }, 3000);

        return () => clearTimeout(timer);

    }, [token, navigate, userRole]);

    // const handleChange = (e) => {
    //     const { name, value } = e.target;
    //     setFormData((prev) => ({ ...prev, [name]: value }));

    //     setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
    // };
    const handleChange = (e) => {
        const { name, value } = e.target;

        if (name === "contact_phone") {
            // ✅ Remove all non-numeric characters
            let cleaned = value.replace(/\D/g, "").slice(0, 10); // Max 10 digits

            // ✅ Format as (XXX) XXX-XXXX
            let formattedPhone = cleaned.replace(
                /^(\d{3})(\d{0,3})?(\d{0,4})?$/,
                (match, p1, p2, p3) => {
                    return p3 ? `(${p1}) ${p2}-${p3}` : p2 ? `(${p1}) ${p2}` : `(${p1}`;
                }
            );

            setFormData((prev) => ({ ...prev, contact_phone: formattedPhone }));
        } else {
            setFormData((prev) => ({ ...prev, [name]: value }));
        }

        setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
    };

    const validateForm = () => {
        let newErrors = {};

        // Improved function to handle all data types
        const getString = (value) => {
            if (value === undefined || value === null) return "";
            return typeof value === "string" ? value.trim() : String(value).trim();
        };

        if (!getString(formData.name)) {
            newErrors.name = "Facility Name is Required";
        }
        if (!getString(formData.license_number)) {
            newErrors.license_number = "License Number is Required";
        }
        if (!getString(formData.address_line1)) {
            newErrors.address_line1 = "Street Address is Required";
        }
        if (!getString(formData.address_city)) {
            newErrors.address_city = "City is Required";
        }
        if (!getString(formData.address_zipcode)) {
            newErrors.address_zipcode = "Zipcode is Required";
        }
        if (!getString(formData.primary_administrator_name)) {
            newErrors.primary_administrator_name = "Administrator Name is Required";
        }
        if (!getString(formData.contact_phone)) {
            newErrors.contact_phone = "Contact Number is Required";
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };



    const fetchQuestions = async () => {
        try {
            const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/facility_questions/`, {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Token ${token}`,
                },
            });

            if (!response.ok) {
                if (response.status === 401) {
                    localStorage.removeItem("token");
                    navigate("/login");
                } else {
                    throw new Error(`Error: ${response.status} ${response.statusText}`);
                }
            }

            const data = await response.json();
            setQuestions(data.map(q => ({ ...q, selected: false }))); // Initialize with selected as false
        } catch (err) {
            // toast.error("Something went wrong, Please try again later", err);
            // navigate('/error');
        }
    };

    const fetchFacility = async () => {
        setLoading(true);
        try {
            const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/facilities/${facilityId}/?cacheBuster=${cacheBuster}`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Token ${token}`,
                },
            });

            if (!response.ok) {
                if (response.status === 401) {
                    localStorage.removeItem("token");
                    navigate("/login");
                } else {
                    throw new Error(`Error: ${response.status} ${response.statusText}`);
                }
            } else {
                const data = await response.json();
                setFacility(data);
                setFormData({
                    address_city: data.address_city || "",
                    address_county: data.address_county || "",
                    address_line1: data.address_line1 || "",
                    address_line2: data.address_line2 || "",
                    address_zipcode: data.address_zipcode || "",
                    alzheimer: data.alzheimer || false,
                    contact_email: data.contact_email || "",
                    contact_phone: data.contact_phone || "",
                    contact_fax: data.contact_fax || "",
                    license_number: data.license_number || "",
                    name: data.name || "",
                    primary_administrator_name: data.primary_administrator_name || "",
                    state: data.state || "",
                    state_facility: data.state_facility || "",
                    tax_id: data.tax_id || "",
                    capacity: data.capacity || "",
                    admin_signature: data.admin_signature?.full_size || "",
                    sponsor_state_name: data.sponsor_state_name || "",
                    sponsor_county_name: data.sponsor_county_name || "",

                });

                // Parse emails
                const emailArray = data.certificate_email_addresses ? data.certificate_email_addresses.split(/\r?\n/) : [];
                setCertificateEmails(emailArray);

                // Parse birthday emails
                const birthdayemailArray = data.birthday_email_addresses ? data.birthday_email_addresses.split(/\r?\n/) : [];
                setBirthdayEmails(birthdayemailArray);

                // Set questions
                setSelectedQuestionIds(data.questions.map(q => q.id));
            }
        } catch (err) {
            // toast.error("Something went wrong, Please try again later", err);
            // navigate('/error');
        } finally {
            setLoading(false);
        }
    };

    const handleEmailChange = (index, value) => {
        const updatedEmails = [...certificateEmails];
        updatedEmails[index] = value;
        setCertificateEmails(updatedEmails);
        setFormData((prev) => ({ ...prev, certificate_email_addresses: updatedEmails.join("\r\n") }));
    };

    const addEmail = () => {
        setCertificateEmails([...certificateEmails, ""]);
        setFormData((prev) => ({ ...prev, certificate_email_addresses: [...certificateEmails, ""].join("\r\n") }));
    };

    const removeEmail = (index) => {
        const updatedEmails = certificateEmails.filter((_, i) => i !== index);
        setCertificateEmails(updatedEmails);
        setFormData((prev) => ({ ...prev, certificate_email_addresses: updatedEmails.join("\r\n") }));
    };

    const handleBirthdayEmailChange = (index, value) => {
        const updatedEmails = [...birthdayEmails];
        updatedEmails[index] = value;
        setBirthdayEmails(updatedEmails);
        setFormData((prev) => ({ ...prev, birthday_email_addresses: updatedEmails.join("\r\n") }));
    };

    const addBirthdayEmail = () => {
        setBirthdayEmails([...birthdayEmails, ""]);
        setFormData((prev) => ({ ...prev, birthday_email_addresses: [...birthdayEmails, ""].join("\r\n") }));
    };

    const removeBirthdayEmail = (index) => {
        const updatedEmails = birthdayEmails.filter((_, i) => i !== index);
        setBirthdayEmails(updatedEmails);
        setFormData((prev) => ({ ...prev, birthday_email_addresses: updatedEmails.join("\r\n") }));
    };

    const toggleQuestion = (id) => {
        setSelectedQuestionIds((prevIds) =>
            prevIds.includes(id) ? prevIds.filter(qId => qId !== id) : [...prevIds, id]
        );
    };

    const handleSignatureSave = (signatureData) => {
        setFormData(prev => ({ ...prev, admin_signature: signatureData }));
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) {
            toast.error("Something Went Wrong!");
            return;
        }

        setIsSubmitting(true);
        setLoading(true);

        const formDataToSend = new FormData(); // Use FormData for file upload

        // Append facility details
        Object.keys(formData).forEach((key) => {
            if (key !== "admin_signature") { // Skip signature for now
                formDataToSend.append(key, formData[key]);
            }
        });

        // Append questions as an array of IDs
        selectedQuestionIds.forEach((id) => {
            formDataToSend.append(`questions`, id);
        });

        // Append signature if it's in Base64 format
        if (formData.admin_signature && String(formData.admin_signature).startsWith("data:image")) {
            formDataToSend.append("admin_signature", formData.admin_signature);
        }


        try {
            const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/facilities/${facilityId}/?cacheBuster=${cacheBuster}`, {
                method: "PATCH",
                headers: {
                    "Authorization": `Token ${token}`, // No Content-Type header for FormData
                },
                body: formDataToSend,
            });

            const data = await response.json();

            if (!response.ok) {
                // Handle API errors here
                let apiErrors = {};

                // Check if there are field-specific errors in the response
                if (data.contact_phone) {
                    apiErrors.contact_phone = data.contact_phone[0] || "Invalid contact phone";
                }

                // Check for other field errors
                Object.keys(data).forEach(key => {
                    if (Array.isArray(data[key]) && data[key].length > 0) {
                        apiErrors[key] = data[key][0];
                    }
                });

                // Update errors state with API errors
                setErrors(prevErrors => ({ ...prevErrors, ...apiErrors }));

                // Show toast for general error
                toast.error(data.admin_signature?.[0] || "Failed to save facility details");
                // throw new Error(data.admin_signature?.[0] || "Failed to save facility details");
            }

            setFormData(data);
            setSelectedQuestionIds(data.questions.map(q => q.id));
            toast.success("Facility details saved successfully!");
            fetchFacility();
            fetchQuestions();

        } catch (error) {
            toast.error(`Failed to update data.`);
            // navigate('/error');
        } finally {
            setLoading(false);
            setIsSubmitting(false);
        }
    };

    const cancel = () => {
        window.history.back();
    }

    return (
        <Master>
            <form onSubmit={handleSubmit}>

                <div className="content">
                    {loading && (
                        <div className="overlay">
                            <div className="loader-wrapper">
                                <Loader height={120} width={120} />
                            </div>
                        </div>
                    )}
                    <ToastContainer />
                    {/* Facility Details Section */}
                    <section className="tasks panel">
                        {/* <div className="panel-heading">
                        <div className="row">
                            <div className="panel-heading-title">
                                <strong>
                                    <span className="glyphicon glyphicon-th"></span> Facility Details
                                </strong>
                            </div>
                        </div>
                    </div> */}
                        <h2 className="text-xxl text-white font-semibold flex items-center gap-2 mb-2 py-6 px-4 rounded-lg shadow-md bg-gradient-to-r from-emerald-600 to-teal-600 border border-emerald-600">
                          <i className="fa-solid fa-house-medical text-3xl mr-2"></i>  Facility Details
                        </h2>
                        <div className="facility-details-form row">
                            <div className="col-sm-6 col-md-3 mb-4">
                                <div className="form-group">
                                    <label className="facility-detail-label">Name</label>
                                </div>
                                {/* </div> */}
                                {/* <div className="col-sm-6 col-md-4">
                            <div className="form-group"> */}
                                <input
                                    type="text"
                                    name="name"
                                    value={formData.name || ""}
                                    onChange={handleChange}
                                    className={`edit-1823form form-control ${errors.name ? "is-invalid" : ""}`}
                                />
                            </div>
                            {errors.name && (
                                <small className="facility-details-error-message text-danger d-block mt-1">{errors.name}</small>
                            )}
                            {/* </div> */}

                            {/* <div className="facility-details-form  mt-3"> */}
                            <div className="col-sm-6 col-md-3">
                                <label className="facility-detail-label">FL License Number</label>
                                {/* </div>
                        <div className="col-sm-6 col-md-4">
                            <div className="form-group"> */}
                                <input
                                    type="text"
                                    name="license_number"
                                    value={formData.license_number || ""}
                                    onChange={handleChange}
                                    className={`edit-1823form form-control ${errors.license_number ? "is-invalid" : ""}`}
                                />
                            </div>
                            {errors.license_number && (
                                <small className="facility-details-error-message text-danger d-block mt-1">{errors.license_number}</small>
                            )}
                            {/* </div> */}
                            {/* </div> */}

                            {/* <div className="facility-details-form row mt-3"> */}
                            <div className="col-sm-6 col-md-3">
                                <div className="form-group">
                                    <label className="facility-detail-label">Capacity</label>
                                </div>
                                {/* </div>
                        <div className="col-sm-6 col-md-4">
                            <div className="form-group"> */}
                                <input
                                    type="text"
                                    name="capacity"
                                    value={formData.capacity}
                                    onChange={handleChange}
                                    className="edit-1823form form-control"
                                />
                            </div>
                            {errors.capacity && (
                                <small className="facility-details-error-message text-danger d-block mt-1">{errors.capacity}</small>
                            )}

                            {/* </div> */}

                            {/* <div className="facility-details-form row mt-3"> */}
                            <div className="col-sm-6 col-md-3">
                                <div className="form-group">
                                    <label className="facility-detail-label">Street Address</label>
                                </div>
                                {/* </div>
                        <div className="col-sm-6 col-md-4">
                            <div className="form-group"> */}
                                <input
                                    type="text"
                                    name="address_line1"
                                    value={formData.address_line1 || ""}
                                    onChange={handleChange}
                                    className={`edit-1823form form-control ${errors.address_line1 ? "is-invalid" : ""}`}
                                />
                            </div>
                            {errors.address_line1 && (
                                <small className="facility-details-error-message text-danger d-block mt-1">{errors.address_line1}</small>
                            )}
                            {/* </div> */}
                            {/* <div className="facility-details-form row mt-3"> */}
                            <div className="col-sm-6 col-md-3 mb-4">
                                <div className="form-group">
                                    <label className="facility-detail-label">Address 2</label>
                                </div>
                                {/* </div>
                        <div className="col-sm-6 col-md-4">
                            <div className="form-group"> */}
                                <input
                                    type="text"
                                    name="address_line2"
                                    value={formData.address_line2 || ""}
                                    onChange={handleChange}
                                    className="edit-1823form form-control"
                                />
                            </div>

                            {/* </div>
                    </div> */}
                            {/* <div className="facility-details-form row mt-3">
                        <div className="col-sm-6 col-md-2">
                            <div className="form-group">
                                <label className="facility-detail-label">Country</label>
                            </div>
                        </div>
                        <div className="col-sm-6 col-md-4">
                            <div className="form-group">
                                <input
                                    type="text"
                                    name="address_county"
                                    value={formData.address_county}
                                    onChange={handleChange}
                                    className="edit-1823form form-control"
                                />
                            </div>
                        </div>
                    </div> */}



                            {/* <div className="facility-details-form row mt-3"> */}
                            <div className="col-sm-6 col-md-3">
                                <div className="form-group">
                                    <label className="facility-detail-label">State</label>
                                </div>
                                {/* </div>
                        <div className="col-sm-6 col-md-4">
                            <div className="form-group"> */}
                                <input
                                    type="text"
                                    name="sponsor_state_name"
                                    value={formData.sponsor_state_name}
                                    onChange={handleChange}
                                    className={`edit-1823form form-control ${errors.sponsor_state_name ? "is-invalid" : ""}`}
                                    readOnly
                                />

                                {errors.address_zipcode && (
                                    <small className="facility-details-error-message text-danger d-block mt-1">{errors.sponsor_state_name}</small>
                                )}
                            </div>
                            {/* </div> */}

                            {/* </div> */}
                            {/* <div className="facility-details-form row mt-3"> */}
                            <div className="col-sm-6 col-md-3">
                                <div className="form-group">
                                    <label className="facility-detail-label">County</label>
                                </div>
                                {/* </div>
                        <div className="col-sm-6 col-md-4">
                            <div className="form-group"> */}
                                <input
                                    type="text"
                                    name="sponsor_state_name"
                                    value={formData.sponsor_county_name}
                                    onChange={handleChange}
                                    className={`edit-1823form form-control ${errors.sponsor_county_name ? "is-invalid" : ""}`}
                                    readOnly
                                />
                                {/* </div> */}


                                {/* </div> */}
                            </div>

                            {/* <div className="facility-details-form row mt-3"> */}
                            <div className="col-sm-6 col-md-3">
                                <div className="form-group">
                                    <label className="facility-detail-label">City</label>
                                </div>
                                {/* </div>
                        <div className="col-sm-6 col-md-4">
                            <div className="form-group"> */}
                                <input
                                    type="text"
                                    name="address_city"
                                    value={formData.address_city}
                                    onChange={handleChange}
                                    className={`edit-1823form form-control ${errors.address_city ? "is-invalid" : ""}`}
                                />
                                {errors.address_city && (
                                    <small className="facility-details-error-message text-danger d-block mt-1">{errors.address_city}</small>
                                )}
                            </div>
                            {/* </div>



                    <div className="facility-details-form row mt-3"> */}
                            <div className="col-sm-6 col-md-3 mb-4">
                                <div className="form-group">
                                    <label className="facility-detail-label">ZIP Code</label>
                                </div>
                                {/* </div>
                        <div className="col-sm-6 col-md-4"> */}
                                <div className="form-group">
                                    <input
                                        type="text"
                                        name="address_zipcode"
                                        value={formData.address_zipcode}
                                        onChange={handleChange}
                                        className={`edit-1823form form-control ${errors.address_zipcode ? "is-invalid" : ""}`}
                                    />
                                </div>
                                {errors.address_zipcode && (
                                    <small className="facility-details-error-message text-danger d-block mt-1">{errors.address_zipcode}</small>
                                )}
                            </div>
                            {/* </div>

                    <div className="facility-details-form row mt-3"> */}
                            <div className="col-sm-6 col-md-3">
                                <div className="form-group">
                                    <label className="facility-detail-label">Primary Administrator</label>
                                </div>
                                {/* </div>
                        <div className="col-sm-6 col-md-4"> */}
                                <div className="form-group">
                                    <input
                                        type="text"
                                        name="primary_administrator_name"
                                        value={formData.primary_administrator_name}
                                        onChange={handleChange}
                                        className={`edit-1823form form-control ${errors.primary_administrator_name ? "is-invalid" : ""}`}
                                    />

                                </div>
                                {errors.primary_administrator_name && (
                                    <small className="facility-details-error-message text-danger d-block mt-1">{errors.primary_administrator_name}</small>
                                )}
                            </div>
                            {/* </div>

                    <div className="facility-details-form row mt-3"> */}
                            <div className="col-sm-6 col-md-3">
                                <div className="form-group">
                                    <label className="facility-detail-label">Phone</label>
                                </div>
                                {/* </div>
                        <div className="col-sm-6 col-md-4"> */}
                                <div className="form-group">
                                    <input
                                        type="text"
                                        name="contact_phone"
                                        value={formData.contact_phone}
                                        onChange={handleChange}
                                        className={`edit-1823form form-control ${errors.contact_phone ? "is-invalid" : ""}`}
                                    />
                                </div>
                                {errors.contact_phone && (
                                    <small className="facility-details-error-message text-danger d-block mt-1">{errors.contact_phone}</small>
                                )}
                            </div>
                            {/* </div>

                    <div className="facility-details-form row mt-3"> */}
                            <div className="col-sm-6 col-md-3">
                                <div className="form-group">
                                    <label className="facility-detail-label">Fax(Optional)</label>
                                </div>
                                {/* </div>
                        <div className="col-sm-6 col-md-4"> */}
                                <div className="form-group">
                                    <input
                                        type="text"
                                        name="contact_fax"
                                        value={formData.contact_fax}
                                        onChange={handleChange}
                                        className="edit-1823form form-control"
                                    />
                                </div>
                                {errors.contact_fax && (
                                    <small className="facility-details-error-message text-danger d-block mt-1">{errors.contact_fax}</small>
                                )}
                            </div>
                            {/* </div>

                    <div className="facility-details-form row mt-3"> */}
                            <div className="col-sm-6 col-md-3 mb-4">
                                <div className="form-group">
                                    <label className="facility-detail-label">E-mail</label>
                                </div>
                                {/* </div>
                        <div className="col-sm-6 col-md-4"> */}
                                <div className="form-group">
                                    <input
                                        type="text"
                                        name="contact_email"
                                        value={formData.contact_email}
                                        onChange={handleChange}
                                        className="edit-1823form form-control"
                                    />
                                </div>
                            </div>
                            {/* </div>

                    <div className="facility-details-form row mt-3"> */}
                            <div className="col-sm-6 col-md-3">
                                <div className="form-group">
                                    <label className="facility-detail-label">NPI(optional)</label>
                                </div>
                                {/* </div>
                        <div className="col-sm-6 col-md-4"> */}
                                <div className="form-group">
                                    <input
                                        type="text"
                                        name="npi"
                                        value={formData.npi}
                                        onChange={handleChange}
                                        className="edit-1823form form-control"
                                    />
                                </div>
                                {errors.npi && (
                                    <small className="facility-details-error-message text-danger d-block mt-1">{errors.npi}</small>
                                )}
                            </div>
                            {/* </div>

                    <div className="facility-details-form row mt-3"> */}
                            <div className="col-sm-6 col-md-3">
                                <div className="form-group">
                                    <label className="facility-detail-label">TIN(Optional)</label>
                                </div>
                                {/* </div>
                        <div className="col-sm-6 col-md-4"> */}
                                <div className="form-group">
                                    <input
                                        type="text"
                                        name="tax_id"
                                        value={formData.tax_id}
                                        onChange={handleChange}
                                        className="edit-1823form form-control"
                                    />
                                </div>
                            </div>
                        </div>
                    </section>

                    {/* Email Notifications Section */}
                    <section className="tasks panel">
                        {/* <div className="panel-heading">
                        <div className="row">
                            <div className="panel-heading-title">
                                <strong>Notifications</strong>
                            </div>
                        </div>
                    </div> */}
                        <h2 className="text-xxl text-white font-semibold flex items-center gap-2 mb-2 py-6 px-4 rounded-lg shadow-md bg-gradient-to-r from-emerald-600 to-teal-600 border border-emerald-600">
                         <i className="fa-solid fa-bell text-3xl mr-2"></i>   Notifications
                        </h2>


                        <div className="panel-body">
                            <label className="facilitynotificationsEmail" htmlFor="notificationEmails">
                                CC Recipients for Certificate Notifications
                            </label>
                            <br />
                            <div className='mb-4' >
                                <small className='text-xl bg-blue-100 py-2 px-4 text-blue-700 rounded'>
                                    Add or update the email addresses of recipients who should receive course completion certificates in CC.
                                    You can include multiple recipients and customize the list as required.
                                </small>
                            </div>
                            <div className="email-list">
                                {certificateEmails.map((email, index) => (
                                    <div key={index} style={{ display: "flex", alignItems: "center", marginBottom: "10px" }}>
                                        <input
                                            type="email"
                                            className="input-section"
                                            value={email}
                                            onChange={(e) => handleEmailChange(index, e.target.value)}
                                            placeholder="Enter email"
                                            style={{ marginRight: "10px", flex: 1, padding: "10px" }}
                                        />
                                        <button type="button" className="btn btn-danger remove-email" onClick={() => removeEmail(index)} style={{ marginLeft: "10px" }}>
                                            Remove
                                        </button>
                                    </div>
                                ))}
                                <button type="button" className="btn btn-primary mt-2 add-email" onClick={addEmail}>
                                    Add Email
                                </button>
                            </div>
                        </div>
                    </section>

  {/* Birthday Notifications Section */}
                    <section className="tasks panel">
                        {/* <div className="panel-heading">
                        <div className="row">
                            <div className="panel-heading-title">
                                <strong>Notifications</strong>
                            </div>
                        </div>
                    </div> */}
                        <h2 className="text-xxl text-white font-semibold flex items-center gap-2 mb-2 py-6 px-4 rounded-lg shadow-md bg-gradient-to-r from-emerald-600 to-teal-600 border border-emerald-600">
                         <i className="fa-solid fa-bell text-3xl mr-2"></i>Birthday Notifications
                        </h2>


                        <div className="panel-body">
                            <label className="birthdaynotificationsEmail" htmlFor="notificationEmails">
                                CC Recipients for Birthday Notifications
                            </label>
                            <br />
                            <div className='mb-4'>
                                <small className='text-xl bg-blue-100 py-2 px-4 text-blue-700 rounded'>
                                    Add or update the email addresses of recipients who should receive birhdays reminder in CC.
                                    You can include multiple recipients and customize the list as required.
                                </small>
                            </div>
                            <div className="email-list">
                                {birthdayEmails.map((email, index) => (
                                    <div key={index} style={{ display: "flex", alignItems: "center", marginBottom: "10px" }}>
                                        <input
                                            type="email"
                                            className="input-section"
                                            value={email}
                                            onChange={(e) => handleBirthdayEmailChange(index, e.target.value)}
                                            placeholder="Enter email"
                                            style={{ marginRight: "10px", flex: 1, padding: "10px" }}
                                        />
                                        <button type="button" className="btn btn-danger remove-email" onClick={() => removeBirthdayEmail(index)} style={{ marginLeft: "10px" }}>
                                            Remove
                                        </button>
                                    </div>
                                ))}
                                <button type="button" className="btn btn-primary mt-2 add-email" onClick={addBirthdayEmail}>
                                    Add Email
                                </button>
                            </div>
                        </div>
                    </section>
                    {/* Services Section */}
                    <section className="tasks panel">
                        {/* <div className="panel-heading">
                            <div className="row">
                                <div className="panel-heading-title">
                                    <strong>Services</strong>
                                </div>
                            </div>
                        </div> */}
                         <h2 className="text-xxl text-white font-semibold flex items-center gap-2 mb-2 py-6 px-4 rounded-lg shadow-md bg-gradient-to-r from-emerald-600 to-teal-600 border border-emerald-600">
                          <i className="fa-solid fa-notes-medical text-3xl mr-2"></i>  Services
                        </h2>
                        <div className="panel-body">
                            {["license", "non-license"].map((type) => (
                                <section key={type} className="panel panel-default">
                                    <div className="panel-body">
                                        <table className="table border">
                                            <tbody>
                                                {questions
                                                    .filter((q) => (type === "license" ? q.is_license : !q.is_license))
                                                    .map((question) => (
                                                        <tr key={question.id}>
                                                            <td className='text-start'>
                                                                <span>{question.question}</span>
                                                            </td>
                                                            <td width="100">
                                                                <label className="switch">
                                                                    <input
                                                                        type="checkbox"
                                                                        checked={selectedQuestionIds.includes(question.id)}
                                                                        onChange={() => toggleQuestion(question.id)}
                                                                    />
                                                                    <i></i>
                                                                </label>
                                                            </td>

                                                        </tr>
                                                    ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </section>
                            ))}
                        </div>
                    </section>


                    {/* Signature Section */}
                    <section className="tasks panel">
                        {/* <div className="panel-heading">
                            <div className="row">
                                <div className="panel-heading-title">
                                    <strong>Administrator Signature</strong>
                                </div>
                            </div>
                        </div> */}
                         <h2 className="text-xxl text-white font-semibold flex items-center gap-2 mb-2 py-6 px-4 rounded-lg shadow-md bg-gradient-to-r from-emerald-600 to-teal-600 border border-emerald-600">
                          <i className="fa-solid fa-file-signature text-3xl mr-2"></i>  Administrator Signature
                        </h2>
                        <div className="panel-body">
                            <FacilitySignatureCanvas
                                onSave={handleSignatureSave}
                                savedSignature={formData.admin_signature}
                            />
                        </div>
                    </section>

                    {/* Save/Cancel Section */}
                    <section className="task panel">
                        <div className="panel panel-default">
                            <div className="panel-body resident-save">
                                <button type="submit" className="btn btn-success resident-save" disabled={isSubmitting}>
                                    {isSubmitting ? "Saving..." : "Save"}
                                </button>
                                <button type="button" className="btn btn-warning resident-cancel" onClick={cancel}>
                                    Cancel
                                </button>
                            </div>
                        </div>
                    </section>
                </div>
            </form>
        </Master>
    );
};

export default FacilityDetail;
